import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data66 from '../../data/data66.json'
import ArticleList from '../../Components/ArticleList';

const DonationTaxQualification: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>公益性捐赠税前扣除资格名单</h1>
                <ArticleList dataId="66" data={data66 as any} />
            </div>
        } />
    );
};

export default DonationTaxQualification;